import ApartmentIcon from "@mui/icons-material/Apartment";
import { resources as Buildings } from "./Buildings";
import { resources as Rooms } from "./Rooms";
import { resources as Campaigns } from "./Campaigns";
import { resources as Accommodations } from "./Accommodations";
import { resources as AccommodatedStudents } from "./AccommodatedStudents";
import { resources as AccommodationOrders } from "./AccommodationOrders";
import { resources as AccommodationPayments } from "./AccommodationPayments";
import { resources as AccommodationPrices } from "./AccommodationPrices";
import { resources as CreateAccommodationPrice } from "./AccommodationPrices/Create";
import { resources as EditAccommodationPrice } from "./AccommodationPrices/Edit";
import { resources as RoomTypes } from "./RoomTypes";
import { resources as RoomConditions } from "./RoomConditions";
import { resources as StateSubsidies } from "./StateSubsidies";
import { resources as CreateStateSubsidy } from "./StateSubsidies/Create";
import { resources as EditStateSubsidy } from "./StateSubsidies/Edit";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.NONE],
  icon: <ApartmentIcon />,
  name: "Общежития",
  title: "Общежития",
  subMenu: [
    Buildings,
    Rooms,
    RoomTypes,
    RoomConditions,
    Campaigns,
    Accommodations,
    AccommodatedStudents,
    AccommodationOrders,
    AccommodationPayments,
    AccommodationPrices,
    CreateAccommodationPrice,
    EditAccommodationPrice,
    StateSubsidies,
    CreateStateSubsidy,
    EditStateSubsidy,
  ],
};
